import { Home } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Fixed, bottom-center floating "back to jobs list" button — always visible
 * regardless of scroll, so the user can return to the Dashboard from any
 * depth without hunting for the button. Rendered on every non-list page.
 *
 * A compact circular FAB (Home icon) rather than a text pill: it fits every
 * page's bottom area — including QuizSession's crowded Prev/Clear/Next footer
 * (a text pill would overflow the centre gap on narrow screens and cover the
 * Submit button). The elevated circle + shadow also make it visually distinct
 * from the flat page content.
 */
export function BackToListButton({
  onHome,
  className,
}: {
  onHome: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onHome}
      aria-label="Back to jobs list"
      title="Jobs list"
      className={cn(
        'fixed bottom-4 left-1/2 z-40 flex h-12 w-12 -translate-x-1/2 items-center justify-center',
        'rounded-full border border-border bg-card text-muted-foreground shadow-lg',
        'transition-colors hover:bg-accent hover:text-foreground',
        className,
      )}
    >
      <Home className="h-5 w-5" />
    </button>
  );
}
